import styles from './BatteryOfflineSummaryVisualization.module.scss';
import {
    PercentageBarSegment,
    PercentageBarVisualization,
} from 'components/data/PercentageBarVisualization/PercentageBarVisualization';
import {
    connectedColor,
    disconnectedColor,
} from 'store/services/device-status';

export interface BatteryOfflineSummaryVisualizationProps {
    /** Number of deployed devices that are online. */
    onlineCount: number;
    /** Number of deployed devices that are offline. */
    offlineCount: number;
}

export const BatteryOfflineSummaryVisualization = ({
    onlineCount,
    offlineCount,
}: BatteryOfflineSummaryVisualizationProps) => {
    const online: PercentageBarSegment = {
        width: (onlineCount / (onlineCount + offlineCount)) * 100,
        backgroundColor: connectedColor,
        name: 'Online',
        tooltip: `${onlineCount} connected devices with low battery`,
    };

    const offline: PercentageBarSegment = {
        width: (offlineCount / (onlineCount + offlineCount)) * 100,
        backgroundColor: disconnectedColor,
        name: 'Offline',
        tooltip: `${offlineCount} offline/disconnected devices with low battery`,
    };

    return (
        <div className={styles.BatteryOfflineSummaryVisualization}>
            <PercentageBarVisualization
                testId="BatteryOfflineSummaryVisualization"
                label="Connected Vs Offline"
                percentageBarSegments={[online, offline]}
            />
        </div>
    );
};
